import DefaultList from "@/components/DefaultList";
import { Module, PATH_CONTRACTOR } from "@/constants";
import { readContractor } from "@/schemas/contractor";
import { fetchContractorsList } from "@/services/contractors";
import { ReadContractor } from "@/types/contractor";
import { useMemo } from "react";
import { Row } from "@tanstack/react-table";
import TaxStatus from "@/components/TaxStatus";
import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { GENDER } from "@/types/common";
import { TAX_STATUS } from "@/schemas/commonFields/taxStatus";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

const ContractorsList = () => {
  const { i18n } = useTranslation();

  const columnOverrides = useMemo(
    () => ({
      gender: {
        id: "gender",
        cell: ({ row }: { row: Row<ReadContractor> }) =>
          i18n.t(`gender.${row.original.gender}`),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: GENDER,
              translationKey: "gender",
            },
          },
        },
      },
      tax_status: {
        id: "tax_status",
        cell: ({ row }: { row: Row<ReadContractor> }) => (
          <TaxStatus value={row.original.tax_status} />
        ),
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: TAX_STATUS,
              translationKey: "taxStatus",
            },
          },
        },
      },
    }),
    [i18n],
  );

  return (
    <DefaultList<ReadContractor>
      schema={readContractor}
      name={Module.Contractors}
      fetchList={fetchContractorsList}
      pathBuilder={(row) =>
        generatePath(PATH_CONTRACTOR, { contractorId: row.id })
      }
      tableFeatures={{
        exportSettings: { moduleName: Module.Contractors },
      }}
      columnOverrides={columnOverrides}
    />
  );
};

export default ContractorsList;
